<div class="container-fluid book-test-drive">
  <div class="row breadcrumb-wrapper">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <app-breadcrumb *ngIf="showBreadCrumb"></app-breadcrumb>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <h1 class="page-sub-title cv-text-dark mb-4 mt-4">
          Book Test Drive
        </h1>
      </div>
      <div class="col-12 col-sm-12 col-md-7 col-lg-8 col-xl-8">
        <div class="row">
          <!--Book Test Drive-->
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 book-test-drive-area position-relative"
            *ngIf="!isShowConfirmation">
            <div class="progress">
              <div class="progress-bar" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0"
                aria-valuemax="100"></div>
            </div>
            <ng-wizard [config]="config" (stepChanged)="stepChanged($event)">
              <ng-wizard-step [title]="'1'" [description]="'Dealer & Date'">

                <div class="pt-3 pb-3">
                  <div class="d-md-none product-info">
                    <div class="order-summary">
                      <img alt="{{productDetailList?.model}}" src="{{ productDetailList?.images[0]?.image_url }}" loading="lazy"/>
                    </div>
                    <div class="product-details">
                      <div class="name-status">
                        {{ productDetailList?.model }}
                      </div>
                      <div class="product-price divider">
                        <p>Ex-showroom Price</p>
                        <div class="product-price-amount">
                          <div class="price">{{ newVCPrice ? (newVCPrice | currency:'INR':'symbol':'4.0-0') : (productDetailList?.price_range | currency:'INR':'symbol':'4.0-0') }} </div>
                          <!-- <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#fetchOn_price">Fetch On-Road
                            Price</a> -->
                        </div>
                      </div>
                      <div class="product-booking-amount divider">
                        <div class="booking-amount">
                          Booking Amount <span>{{ productDetailList?.down_payment |
                            currency:'INR':'symbol':'4.0-0'
                            }} </span>
                        </div>
                        <div class="product-quantity">
                          Quantity <span>1</span>
                        </div>
                      </div>
                      <div class="total-booking-amount">
                        Total Booking Amount <span>₹10000</span>
                      </div>
                    </div>
                  </div>
                  <form [formGroup]="testDriveForm">
                    <div class="row">
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div class="pt-3 pb-3">
                          <h3 class="sub-title text-uppercase mb-3">Where you want to have your test drive?</h3>
                          <ul class="nav nav-pills nav-fill mb-3" id="pills-tab" role="tablist">
                            <li class="nav-item" role="presentation">
                              <button class="nav-link active" id="pills-showroom-tab" data-bs-toggle="pill"
                                data-bs-target="#pills-showroom" type="button" role="tab" aria-controls="pills-showroom"
                                aria-selected="true" (click)="selectTestDrive('At showroom')"
                                data-toggle="tooltip" data-placement="top" title="Click here to book TestDrive At Showroom"
                                >At showroom</button>
                            </li>
                            <li class="nav-item" role="presentation">
                              <button class="nav-link" id="pills-doorstep-tab" data-bs-toggle="pill" *ngIf="!isdealer"
                                data-bs-target="#pills-doorstep" type="button" role="tab" aria-controls="pills-doorstep"
                                aria-selected="false" (click)="selectTestDrive('At Doorstep')"
                                data-toggle="tooltip" data-placement="top" title="Click here to book TestDrive At Doorstep"
                                >At Doorstep</button>
                            </li>
                            <!-- <li class="nav-item" role="presentation">
                              <button class="nav-link" id="pills-demo-tab" data-bs-toggle="pill"
                                data-bs-target="#pills-demo" type="button" role="tab" aria-controls="pills-demo"
                                aria-selected="false" (click)="selectTestDrive('Online Demo')">Online Demo</button>
                            </li> -->
                          </ul>
                        </div>
                        <div class="tab-content" id="pills-tabContent">
                          <div class="tab-pane fade show active" id="pills-showroom" role="tabpanel"
                            aria-labelledby="pills-showroom-tab" tabindex="0">
                            <div class="selectDealer-div mb-4">
                              <div class="sub-title">Select Dealer</div>
                              <div class="row g-4">
                                <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4" [ngClass]="{'d-none':isdealer}">
                                  <label for="selState">State<span>*</span></label>
                                  <select name="selState" formControlName="state" id="selState" class="form-select"
                                    (change)="getDistrictList()">
                                    <option selected value="">Select State</option>
                                    <option *ngFor="let item of stateList" value="{{[item.name , item.code]}}">
                                      {{item.name}}</option>
                                  </select>
                                  <div class="error-message" *ngIf="hasRequiredError('state') && !testDriveForm.controls['state'].value">
                                    <b> &nbsp; *Required</b>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4" [ngClass]="{'d-none':isdealer}">
                                  <label for="selDist">District<span>*</span></label>
                                  <select name="selDist" formControlName="district" id="selDist" class="form-select"
                                    (change)="getCity()">
                                    <option selected value="">Select District</option>
                                    <option *ngFor="let item of districtList" value="{{item}}">{{item}}</option>
                                  </select>
                                  <div class="error-message" *ngIf="hasRequiredError('district') && !testDriveForm.controls['district'].value">
                                    <b> &nbsp; *Required</b>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4" [ngClass]="{'d-none':isdealer}">
                                  <label for="selCity">City<span>*</span></label>
                                  <select name="selCity" id="selCity" formControlName="city" class="form-select"
                                    (change)="getDealer()">
                                    <option selected value="">Select City</option>
                                    <option *ngFor="let item of cityList" value="{{item}}">{{item}}</option>
                                  </select>
                                  <div class="error-message" *ngIf="hasRequiredError('city') && !testDriveForm.controls['city'].value">
                                    <b> &nbsp; *Required</b>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4">
                                  <label for="selDealer">Dealer<span>*</span></label>
                                  <select name="selDealer" id="selDealer" class="form-select" formControlName="dealer"
                                    (change)="onDealerSelection()">
                                    <option selected value="">Select Dealer</option>
                                    <option *ngFor="let item of dealerList" value="{{item.division_id}}">
                                      {{item.organization_name}}
                                    </option>
                                  </select>
                                  <div class="error-message" *ngIf="hasRequiredError('dealer') && !testDriveForm.controls['dealer'].value">
                                    <b> &nbsp; *Required</b>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                          <div class="tab-pane fade" id="pills-doorstep" role="tabpanel"
                            aria-labelledby="pills-doorstep-tab" tabindex="0">
                            <div class="pt-3 pb-3 address-iformation">
                              <div class="d-flex mb-3 align-items-center address-heading">
                                <h3 class="sub-title mend">Your address</h3>
                                <!-- <a href="javascript:void(0);" class="ms-auto" *ngIf="!isTestDriveDoorstepSubmitted">Change Address</a> -->
                                <a href="javascript:void(0);" class="ms-auto" data-bs-toggle="modal" data-bs-target="#add-edit-address-modal" *ngIf="isTestDriveDoorstepSubmitted">Edit Address</a>
                              </div>

                              <div class="d-grid address-cta">
                                <button *ngIf="!isTestDriveDoorstepSubmitted" type="button" class="btn d-flex align-items-center justify-content-center  btn-outline-primary btn-grad-outline-primary"
                                 data-bs-toggle="modal" data-bs-target="#add-edit-address-modal"
                                 data-toggle="tooltip" data-placement="top" title="Please Add your Address">
                                 <img [src]="environment1 + 'images/new-images/add.svg'" alt="add" loading="lazy">
                                  Add Your Address</button>
                              </div>
                              <div class="adress-card" *ngIf="isTestDriveDoorstepSubmitted">
                                <h6>Address<span>*</span></h6>
                                <div class="card">
                                  <div class="card-body">
                                    <p>{{testDriveDoorStepForm.value.address}}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="tab-pane fade" id="pills-demo" role="tabpanel" aria-labelledby="pills-demo-tab"
                            tabindex="0">
                            <div class="selectDealer-div mb-4">
                              <div class="sub-title">Select Dealer</div>
                              <div class="row g-4">
                                <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4">
                                  <label for="selState">State<span>*</span></label>
                                  <select name="selState" formControlName="state" id="selState" class="form-select"
                                    (change)="getDistrictList()">
                                    <option selected value="">Select State</option>
                                    <option *ngFor="let item of stateList" value="{{[item.name , item.code]}}">
                                      {{item.name}}</option>
                                  </select>
                                  <div class="error-message" *ngIf="hasRequiredError('state')">
                                    <b> &nbsp; *Required</b>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4">
                                  <label for="selDist">District<span>*</span></label>
                                  <select name="selDist" formControlName="district" id="selDist" class="form-select"
                                    (change)="getCity()">
                                    <option selected value="">Select District</option>
                                    <option *ngFor="let item of districtList" value="{{item}}">{{item}}</option>
                                  </select>
                                  <div class="error-message" *ngIf="hasRequiredError('district')">
                                    <b> &nbsp; *Required</b>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4">
                                  <label for="selCity">City<span>*</span></label>
                                  <select name="selCity" id="selCity" formControlName="city" class="form-select"
                                    (change)="getDealer()">
                                    <option selected value="">Select City</option>
                                    <option *ngFor="let item of cityList" value="{{item}}">{{item}}</option>
                                  </select>
                                  <div class="error-message" *ngIf="hasRequiredError('city')">
                                    <b> &nbsp; *Required</b>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4">
                                  <label for="selDealer">Dealer<span>*</span></label>
                                  <select name="selDealer" id="selDealer" class="form-select" formControlName="dealer"
                                    (change)="onDealerSelection()">
                                    <option selected value="">Select Dealer</option>
                                    <option *ngFor="let item of dealerList" value="{{item.division_id}}">
                                      {{item.organization_name}}
                                    </option>
                                  </select>
                                  <div class="error-message" *ngIf="hasRequiredError('dealer')">
                                    <b> &nbsp; *Required</b>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> -->
                        </div>
                      </div>
                      <!--time Schedule-->
                      <div class="test-drive-timeschedule">
                        <h3 class="sub-title  mb-3">Select date for test
                          drive
                          <span style="color: red;">*</span>
                        </h3>
                        <div class="schedule-carousel-sec">
                          <owl-carousel-o [options]="dateScheduleOption">
                            <ng-template carouselSlide *ngFor="let item of dateList; let i=index">
                              <div class="time-card">
                                <input type="radio" class="btn-check" name="options-outlined-dates"
                                  (click)="selectedTime(item.convertDate,'date',i)" id="{{'check'+i}}" autocomplete="off">
                                <label class="btn btn-outline-secondary" for="{{'check'+i}}"><span
                                    class="date d-block">{{item.dd}}</span><span
                                    class="day d-block">{{item.dayValue}}</span></label>
                              </div>
                            </ng-template>
                          </owl-carousel-o>
                        </div>
                      </div>
                      <div class="timeSelect pt-3 pb-4" *ngIf="isShowTime">
                        <h3 class="sub-title  mb-3">Select Time</h3>
                        <div class="d-flex flex-wrap gap-3">
                          <div class="time-card" *ngFor="let item of timeList; let i=index">
                            <input type="radio" class="btn-check" name="time" id="{{'time'+i}}"
                              autocomplete="off" (click)="selectedTime(item,'time',i)">
                            <label class="btn btn-outline-secondary" for="{{'time'+i}}">{{item}}</label>
                          </div>
                        </div>
                      </div>
                      <div class="note mb-5" *ngIf="isDoorStep">Note: Test drive at home will be charged with ₹1000 of
                        fuel cost</div>
                      <div class="col-12 col-sm-5 col-md-5 col-lg-4 col-xl-4 ms-sm-auto mb-4">
                        <button class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100  h-56"
                          (click)="showNextStep()"
                          data-toggle="tooltip" data-placement="top" title="Click here to Continue">Continue</button>
                      </div>
                    </div>
                  </form>
                </div>
              </ng-wizard-step>

              <ng-wizard-step [title]="'2'" [description]="'Personal information'">
                <div class="pt-3 pb-3 personal-info" *ngIf="isShowPersonalInfo">
                  <h3 class="sub-title text-uppercase mb-3">Enter your personal details</h3>
                  <form [formGroup]="personalInfoForm">
                    <div class="row">
                      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-3">
                        <label for="firstName">First Name<span>*</span></label>
                        <input type="text" formControlName="firstName" [disabled]="true" class="form-control"
                          placeholder="Ex: Pratik"  maxlength="45"

                          (keydown)="notAllowSpace($event)">
                          <div class="error-message" *ngIf="hasRequiredError1('firstName')">
                            <b> &nbsp; *Required</b>
                        </div>

                      </div>
                      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-3">
                        <label for="lastName">Last Name<span>*</span></label>
                        <input type="text" class="form-control" formControlName="lastName" maxlength="45"
                          placeholder="Ex: Pratik"
                        (keydown)="notAllowSpace($event)"   >
                        <div class="error-message" *ngIf="hasRequiredError1('lastName')">
                          <b> &nbsp; *Required</b>
                      </div>
                      </div>
                      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-3">
                        <div class="input-mobile">
                          <label for="mobileNo">Mobile No.<span>*</span></label>
                          <input type="text" class="form-control mobile-control"
                          (keydown)="notAllowSpace($event)" onkeydown="return /[0-9]/i.test(event.key)"
                          numbersOnly allowNumbersOnly:true
                            formControlName="mobileNo" placeholder="Ex: 9768xxxxxx">
                          <span class="contry-code"><img [src]='environment1 + "assets/images/ind-flag.svg"' class="img-fluid" loading="lazy"/>
                            +91</span>
                            <div class="error-message" *ngIf="hasRequiredError1('mobileNo')">
                              <b> &nbsp; *Required</b>
                          </div>
                        </div>

                      </div>
                      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                        <label for="email">Email</label>
                        <input type="email"
                        (keyup)="emailValidator($event)"
                        (keydown)="nAllowSpace($event)"
                        onkeydown="return /[a-z0-9^.+@.+\\..+$]/i.test(event.key)"
                        class="form-control" formControlName="email" placeholder="Ex: xyz@mail.com">
                        <div class="error-message" *ngIf="showEmailError">
                          <b> &nbsp; *Invalid</b>
                      </div>
                      </div>
                      <div class="col-12 col-sm-5 col-md-5 col-lg-4 col-xl-4 ms-sm-auto mb-4">
                        <button class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100"
                          (click)="showPersonalInfo()"
                          data-toggle="tooltip" data-placement="top" title="Click here to Book a Test Drive">Book a test drive</button>
                      </div>
                    </div>
                  </form>
                </div>
              </ng-wizard-step>

            </ng-wizard>
          </div>
          <!--Book Test Drive Confirmation-->
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 pt-5 pb-5" *ngIf="isShowConfirmation">
            <div class="confirmation-area">
              <div class="img-box">
                <img [src]='environment1 + "assets/images/ic-con-f.svg"' class="img-fluid" alt="ic-con-f" loading="lazy">
              </div>
              <div class="content-area">
                <h3 class="page-sub-title cv-text-dark">Test drive confirmed</h3>
                <!-- <p>Test drive confirmed. A confirmation mail with the test drive details has been sent
                  to your email address.</p> -->
                <div class="note pt-3" *ngIf="isDoorStep">Note: Test drive at home will be charged with ₹1000 of
                  fuel cost</div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <h6>Dealer</h6>
                  <div class="card">
                    <div class="card-body">
                      <div class="dealer-name d-inline-flex">
                        <div class="icon-box">
                          <img [src]="environment1 + 'images/new-images/map.svg'" alt="map" loading="lazy">
                        </div>
                        <span>{{dealerList[0].organization_name}}</span>
                      </div>
                      <div class="dealer-address">{{dealerList[0]?.address_line1?dealerList[0]?.address_line1 + ',':'' +
                        dealerList[0]?.address_line2?dealerList[0]?.address_line2 + ',':'' +
                        dealerList[0]?.area?dealerList[0]?.area + ',':''
                        + dealerList[0]?.city?dealerList[0]?.city + ',':'' +
                        dealerList[0]?.pincode?dealerList[0]?.pincode + ',':''
                        }}</div>
                      <div class="dealer-contact d-inline-flex">
                        <div class="icon-box">
                          <img [src]="environment1 + 'images/new-images/phone.svg'" alt="phone" loading="lazy">
                        </div>
                        <a href="tel:+91 12345 67890">+91 {{dealerList[0]?.mobile_number}}</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <h6>Date & Location</h6>
                  <div class="card">
                    <div class="card-body">
                      <div class="dealer-date d-flex">
                        <div class="icon-box">
                          <img [src]="environment1 + 'images/new-images/calender.svg'" alt="calender" loading="lazy">
                        </div>
                        <span>{{selectedDateTime | date : 'dd/MM/YYYY'}}</span>
                      </div>

                      <div class="dealer-location d-flex">
                        <div class="icon-box">
                          <img [src]="environment1 + 'images/new-images/location.svg'" alt="location" loading="lazy">

                        </div>
                        <span>{{td_type}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-5 col-md-5 col-lg-4 col-xl-4 ms-sm-auto mb-4">
                  <button class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100 "
                  data-toggle="tooltip" data-placement="top" title="Click here to go to home page"
                    routerLink="/home">Back to home</button>
                </div>
              </div>

            </div>
            <!-- <div class="confirmation-area online-demo-conf">
              <div class="img-box">
                <img [src]='environment1 + "assets/images/ic-con-f.png"' class="img-fluid" alt="" loading="lazy">
              </div>
              <div class="content-area">
                <h3 class="page-sub-title cv-text-dark">Online Demo confirmed</h3>
                <p>Your Online Demo has been confirmed. You will receive an sms on the
                  <span>+91-{{afterBookingDataList.mobile_number}}</span> with
                  the video call link for the same.</p>
              </div>

            </div> -->
          </div>
        </div>
      </div>

      <ng-container *ngIf="!productDetailList || !productLoaded ;else productTemplate">
        <div class="col-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 product-info">
          <div class="order-summary">
            <ngx-skeleton height="200px" width="300px"></ngx-skeleton>
          </div>
          <div class="product-details">
            <div class="name-status">
              <ngx-skeleton height="15px"></ngx-skeleton>
            </div>
            <div class="product-price divider">
              <ngx-skeleton height="15px"></ngx-skeleton>
            </div>
            <div class="product-booking-amount divider">
              <div class="booking-amount">
                <ngx-skeleton height="15px" width="300px"></ngx-skeleton>
              </div>
              <div class="product-quantity">
                <ngx-skeleton height="15px" width="300px"></ngx-skeleton>
              </div>
            </div>
            <div class="total-booking-amount">
              <ngx-skeleton height="15px" width="300px"></ngx-skeleton>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #productTemplate>
      <div class="col-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 product-info d-none d-md-block">
        <div class="order-summary">
          <img alt="{{ productDetailList?.model }}" src="{{ productDetailList?.images[0]?.image_url }}" loading="lazy"/>
        </div>
        <div class="product-details">
          <div class="name-status">
            {{ productDetailList?.model }}
          </div>
          <div class="product-price divider">
            <p>Ex-showroom Price</p>
            <div class="product-price-amount">
              <div class="price">{{ newVCPrice ? (newVCPrice | currency:'INR':'symbol':'4.0-0') : (productDetailList?.price_range | currency:'INR':'symbol':'4.0-0') }} </div>
            </div>
          </div>
          <div class="product-booking-amount divider">
            <div class="booking-amount">
              Booking Amount <span>{{ productDetailList?.down_payment |
                currency:'INR':'symbol':'4.0-0'
                }} </span>
            </div>
            <div class="product-quantity">
              Quantity <span>1</span>
            </div>
          </div>
          <div class="total-booking-amount">
            Total Booking Amount <span>{{ productDetailList?.down_payment |
              currency:'INR':'symbol':'4.0-0'
              }}</span>
          </div>
        </div>
      </div>
      </ng-template>
    </div>
  </div>
</div>

<!--Add / Edit address modal-->
<div class="modal fade add-edit-address-modal" id="add-edit-address-modal" data-bs-backdrop="static"
  data-bs-keyboard="false" tabindex="-1" aria-labelledby="add-edit-address-modalLabel" aria-hidden="true">
  <div class="modal-dialog modal-right modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="add-edit-address-modalLabel">Add Address</h5>
        <button type="button" id="atDoorStepCloseBtn" #atDoorStepCloseBtn class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" style="height: calc(100vh - 130px);">
        <form  [formGroup]="testDriveDoorStepForm">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
              <div class="" style="border-radius: 8px;">
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
              <label class="form-label mend">Address</label>
              <textarea formControlName="address" (keydown)="notAllowSpace($event)"  class="form-control form-control-lg"></textarea>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
              <label class="form-label mend">State</label>
              <select name="selState" formControlName="state" id="selState" class="form-select"
                (change)="getDistrictList()">
                <option selected value="">Select State</option>
                <option *ngFor="let item of stateList" value="{{[item.name , item.code]}}">
                  {{item.name}}</option>
              </select>
              <div class="error-message" *ngIf="hasRequiredError('state') && !testDriveDoorStepForm.controls['state'].value">
                <b> &nbsp; *Required</b>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
              <label class="form-label mend">District</label>
              <select name="selDist" formControlName="district" id="selDist" class="form-select"
                (change)="getCity()">
                <option selected value="">Select District</option>
                <option *ngFor="let item of districtList" value="{{item}}">{{item}}</option>
              </select>
              <div class="error-message" *ngIf="hasRequiredError('district') && !testDriveDoorStepForm.controls['district'].value">
                <b> &nbsp; *Required</b>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
              <label class="form-label mend">City</label>
              <select name="selCity" id="selCity" formControlName="city" class="form-select" (change)="getDealer()">
                <option selected value="">Select City</option>
                <option *ngFor="let item of cityList" value="{{item}}">{{item}}</option>
              </select>
              <div class="error-message" *ngIf="hasRequiredError('city') && !testDriveDoorStepForm.controls['city'].value">
                <b> &nbsp; *Required</b>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
              <label for="selDealer" class="form-label mend">Dealer</label>
              <select name="selDealer" id="selDealer" class="form-select" formControlName="dealer"
                (change)="onDealerSelection()">
                <option selected value="">Select Dealer</option>
                <option *ngFor="let item of dealerList" value="{{item.division_id}}">
                  {{item.organization_name}}
                </option>
              </select>
              <div class="error-message" *ngIf="hasRequiredError('dealer') && !testDriveDoorStepForm.controls['dealer'].value">
                <b> &nbsp; *Required</b>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer justify-content-start">
        <button (click)="saveProceed()" type="button"
        data-toggle="tooltip" data-placement="top" title="Click here to Confirm Test Drive"
        class="btn btn-primary btn-grad-primary btn-comment w-100 pt-2 pb-2">Save & Proceed</button>
            </div>
    </div>
  </div>
</div>
